import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import Research from './pages/Research/Research';
import SmolLM2Report from './pages/SmolLM2Report/SmolLM2Report';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="container">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/smollm2-report" element={<SmolLM2Report />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;